<template>
    <div class="task-detail-title">
        <ul class="task-detail-title-row d-flex">
            <li class="task-name">
                <template v-if="!isEditName">
                <h4 
                    v-if="canEditKpiTask && checkPermission('task.task_name_edit',selectedProject?.isGlobalPermission) === true"
                    class="title-name"
                    :title="taskName"
                    @click="isEditName = true, editTaskName = taskName"
                >
                    {{ taskName }}
                </h4>
                <h4 
                    v-else
                    class="title-name"
                    :title="taskName"
                >
                    {{ taskName }}
                </h4>
                </template>
                <span v-else>
                    <InputText
                        input-id="taskNameEdit"
                        v-model="editTaskName"
                        :is-direct-focus="true"
                        :max-length="250"
                        @blur="editFocusOut()"
                        :place-holder="$t('Projects.task_name')"
                        @enter="$emit('update:taskName', editTaskName), isEditName = false"
                        height="25px"
                        :isOutline="false"
                    />
                </span>
                <button v-if="!isEditName && !isSupport" class="task-copy-id-btn" type="button" @click="copyTaskId">
                    <img :src="copyIcon" class="copy-icon" alt="" />
                    {{ $t('ProjectDetails.copy_id') }}
                </button>
            </li>
        </ul>
    </div>
</template>
<script setup>
    import { useCustomComposable } from '@/composable';
    import { defineProps, defineEmits,inject,ref } from 'vue';
    import { useI18n } from "vue-i18n";
    import InputText from '@/components/atom/InputText/InputText.vue';
    import { useToast } from 'vue-toast-notification';
    import copyIcon from "@/assets/images/svg/content_copy.svg";

    const { checkPermission } = useCustomComposable();
    const { t } = useI18n();

    defineEmits(["update:taskName", "update:favourite", "update:taskType"])
    const props = defineProps({
        favourites: Array,
        taskType: Number,
        taskName: String,
        task: {
            type: Object,
            default: () => ({})
        },
        isSupport: {
            type: Boolean,
            default: false
        },
        canEditKpiTask: {
            type: Boolean,
            default: true
        }
    });

    const $toast = useToast();

    const editTaskName = ref('');
    const selectedProject = inject("selectedProject");

    const isEditName = ref(false); 

    const editFocusOut = () => {
        if(isEditName.value) {
            isEditName.value = false;
        }
        editTaskName.value = '';
    }

    const copyTaskId = () => {
        const value = props.task?.TaskKey || props.task?._id || props.taskName || "";
        if(!value) return;
        $toast.success(t("Common.copied_successfully"), {position: "top-right"})
        navigator.clipboard.writeText(value);
    }
</script>
<style src="./style.css"></style>
